export const socialMediaDictionary = {
  linkedin: { baseUrl: "https://www.linkedin.com/in/" },
  linkedinCompany: { baseUrl: "https://www.linkedin.com/company/" },
  twitter: { baseUrl: "https://twitter.com/" },
  facebook: { baseUrl: "https://www.facebook.com/" },
  instagram: { baseUrl: "https://www.instagram.com/" },
}